export interface PhoneEntry { id: string; value: string; }

export interface MemberData {
    _key:            string;
    salutation:      string;
    title:           string;
    firstName:       string;
    lastName:        string;
    specialty:       string[];
    email:           string;
    password:        string;
    confirmPassword: string;
    phones:          PhoneEntry[];
    iban:            string;
    bic:             string;
    taxNumber:       string;
    avatar:          string; // base64 data-URL or ""
    userRights:      number;
}

export interface RegisterFormData {
    // Step 1 – Praxis
    praxisName:            string;
    praxisEmail:           string;
    praxisPassword:        string;
    praxisConfirmPassword: string;
    praxisId:              string;
    praxisIdManual:        boolean;
    adminFirstName?:       string;
    adminLastName?:        string;
    specialization:        string[];
    logo:                  string; // base64 data-URL or ""
    phones:                PhoneEntry[];
    // Step 2 – Address
    street: string;
    plz:    string;
    city:         string;
    country:      string;
    // Step 3 – Banking
    iban:         string;
    bic:          string;
    taxNumber:    string;
    ibanConsent:  boolean;
    // Step 4 – Plan
    plan: number;
    // Step 5 – Members
    members: MemberData[];
}

// Doctor roles: Admin (3) + Doctor (2)
// Staff roles:  Medical Assistant (1) + Accounting (5)
export const DOCTOR_ROLES = new Set([2, 3]);
export const STAFF_ROLES  = new Set([1, 5]);

// Plan → max doctors (Admin counts as a doctor)
export const PLAN_MAX_DOCTORS: Record<number, number> = {
    1: 1,
    2: 2,
    3: 2,
};

// Plan → max staff (Medical Assistant / Accounting)
export const PLAN_MAX_STAFF: Record<number, number> = {
    1: 0,
    2: 1,
    3: 2,
};

// Plan → max total members (admin + additional) — kept for backwards compat
export const PLAN_MAX_MEMBERS: Record<number, number> = {
    1: 1,
    2: 3,
    3: 4,
};

export const PLAN_PRICES: Record<number, string> = {
    1: "€79",
    2: "€99",
    3: "€149",
};

export const PLAN_NAMES: Record<number, string> = {
    1: "Basic",
    2: "Plus",
    3: "Pro",
};

export const SALUTATION_OPTIONS = ["Herr", "Frau", "Divers"];
export const TITLE_OPTIONS      = ["", "Dr.", "Prof.", "Prof. Dr."];
// UserRole numeric values (mirrors backend enum)
export const USER_ROLES = [
    { value: 3, labelKey: "register.roleAdmin" },
    { value: 2, labelKey: "register.roleDoctor" },
    { value: 1, labelKey: "register.roleMedicalAssistant" },
    { value: 5, labelKey: "register.roleAccounting" },
];
